import { FormlyFieldConfig } from '@ngx-formly/core';

export const addonsExtension = (field: FormlyFieldConfig): void => {
	if (!field.props || (field.wrappers && field.wrappers.indexOf('addons') !== -1)) {
		return;
	}

	if (field.props.addonLeft || field.props.addonRight) {
		field.wrappers = [...(field.wrappers || []), 'addons'];
	}
};
